import React from "react";

import {
  CautionMinorOutlineIcon,
  InfoIcon,
  WarningOutlineIcon,
} from "@whoosh/design-system/src/components/icons_v2/general";
import { IconProps } from "@whoosh/design-system/src/components/primitive";

import { RestrictionFeature } from "../../../../types";

type RestrictionInfoBarIconProps = IconProps & {
  variation: RestrictionFeature.RestrictionVariation;
};

export const RestrictionInfoBarIcon = ({
  variation,
  ...iconProps
}: RestrictionInfoBarIconProps) => {
  if (variation === "error") {
    return <WarningOutlineIcon {...iconProps} />;
  } else if (variation === "warning") {
    return <CautionMinorOutlineIcon {...iconProps} />;
  } else {
    return <InfoIcon {...iconProps} />;
  }
};
